import * as React from 'react';

declare const rootUrl: string;

interface PositionStepsProps {
    onComplete: () => void;
    onBack: () => void;
}

export const PositionSteps = ({ onComplete, onBack }: PositionStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Position Microphone and Sensor</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>On the sensor peel back the larger portion of the protective covering</li>
                            <li>Prepare the area then adhere the chest sensor to the subject so that the sticky pad touches the bottom of the suprasternal notch and the sensor wire hangs down. The suprasternal notch is a large, visible dip located between the neck and the collarbone</li>
                            <li>Remove the remaining protective covering from the sensor sticky pad</li>
                            <li>Clip the microphone to the outside of the subject's clothing, between 4 and 6 inches (10cm and 15cm) away from the subject's mouth</li>
                            <li>Select 'START RECORDING'</li>
                            <li>Ensure both the microphone and chest sensor bar graphs are responding to noise</li>
                            <li>Press enter to begin the recording. <b>Note:</b> Sound recording will <u>not</u> begin until this step is completed</li>
                            <li>Verify the recording has started by confirming the VitaloJAK screen is blank and the indicator light on the side of the device is flashing red</li>
                            <li>Seal the device into the pouch and secure tightly with a zip tie. Fasten VitaloJAK pouch around subject’s waist and provide guidance to subject for recording period</li>
                        </ol>
                    </div>
                    <div className="col-md-12 text-center">
                        <img style={{ width: '100%', maxWidth: '500px' }} src={rootUrl + '/Images/Wizards/vitalojak1-4.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onComplete}>Finish</button>
                <button className="btn btn-primary btn-outline" onClick={onBack}>Back</button>
            </div>
        </>
    );
}
